<app-auth-shell title="Entrar com código no WhatsApp" subtitle="Use o telefone já vinculado à conta. O e-mail precisa estar confirmado.">
  <form role="form" [formGroup]="formWhatsapp" (ngSubmit)="verifyCode()">
    <div class="auth-field">
      <label class="auth-field__label" for="phone">Telefone</label>
      <div class="auth-field__control">
        <input
          id="phone"
          type="tel"
          formControlName="phone"
          class="auth-field__input"
          placeholder="(11) 98765-4321"
          autocomplete="tel"
          appFocus
        />
      </div>
      @if (formWhatsapp.get('phone')?.touched || formWhatsapp.get('phone')?.dirty) {
        @if (formWhatsapp.get('phone')?.hasError('required')) {
          <div class="auth-field__error">Campo obrigatório</div>
        }
        @if (formWhatsapp.get('phone')?.hasError('minLength')) {
          <div class="auth-field__error">Informe um telefone válido</div>
        }
      }
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="code">Código</label>
      <div class="auth-field__control">
        <input
          id="code"
          type="text"
          inputmode="numeric"
          formControlName="code"
          class="auth-field__input"
          placeholder="000000"
          maxlength="6"
          autocomplete="one-time-code"
        />
      </div>
      @if (formWhatsapp.get('code')?.touched || formWhatsapp.get('code')?.dirty) {
        @if (formWhatsapp.get('code')?.hasError('required')) {
          <div class="auth-field__error">Campo obrigatório</div>
        }
        @if (formWhatsapp.get('code')?.hasError('minLength') || formWhatsapp.get('code')?.hasError('maxLength')) {
          <div class="auth-field__error">Informe os 6 dígitos</div>
        }
      }
      @if (hasRequestedCode && validitySeconds > 0) {
        <div class="auth-field__hint">Código válido por {{ formatCountdown(validitySeconds) }}</div>
      }
      @if (hasRequestedCode && validitySeconds === 0) {
        <div class="auth-field__error">Código expirado. Solicite outro.</div>
      }
    </div>
    <div class="auth-field__action">
      <button type="button" class="auth-link" (click)="requestCode()" [disabled]="remainingSeconds > 0">
        @if (remainingSeconds > 0) {
          Reenviar em {{ formatCountdown(remainingSeconds) }}
        } @else if (hasRequestedCode) {
          Reenviar código
        } @else {
          Enviar código
        }
      </button>
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formWhatsapp.valid || !hasRequestedCode || validitySeconds === 0">Entrar</button>
  </form>
  <div class="auth-shell__links">
    <p class="auth-shell__links-text">
      Prefere senha?
      <a class="auth-link" [routerLink]="['/signin']">Entrar</a>
    </p>
    <p class="auth-shell__legal">
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">SOFTClass</a>
      ·
      <a href="https://erpclass.com.br/" target="_blank" rel="noopener noreferrer">erpclass.com.br</a>
    </p>
  </div>
</app-auth-shell>
